import type { EmployeeWithBeneficiariesFormatted } from '@/api/employees/employees.types';
import { Table } from '@/components/table/Table';
import { useTableState } from '@/components/table/useTableState';
import type { ActionLogFormatted } from '@/features/beneficiaries/beneficiaries.types';
import { actionLogsColumns } from '../columns/action-logs-columns';

interface EmployeeActionsProps {
  employee: EmployeeWithBeneficiariesFormatted;
  search: string;
  dateFilter?: Date | null;
}

export function EmployeeActions(props: EmployeeActionsProps) {
  const { employee, search, dateFilter } = props;
  const actions: ActionLogFormatted[] = employee.actionLogs;
  const tableState = useTableState('employee-actions', { columns: actionLogsColumns });

  return (
    <Table
      entity={{ singular: 'intervention', feminine: true }}
      data={actions}
      columns={actionLogsColumns}
      search={search}
      // The parent's DatePicker owns the date column and stays ephemeral: it is injected over
      // the controller's filters so it is neither persisted nor cleared by the reset strip.
      tableState={{
        ...tableState,
        columnFilters: [
          ...tableState.columnFilters.filter((filter) => filter.id !== 'dateTime'),
          ...(dateFilter ? [{ id: 'dateTime', value: dateFilter }] : []),
        ],
      }}
    />
  );
}
